module.exports = __webpack_public_path__ + "img/0Q3A4226_L_Black_MockedUp.2e4fee60.jpg";